export default __webpack_public_path__ + "assets/front/scss/common.2078f8e9f87b55b3fea0d642fa856af3.css";